import { FC } from 'react';
import { INavBanner, INavItem } from 'mod/store/nav/interface';
import { Row, Col } from '@base/lib/ThemeGrid';
import Image from '@base/lib/ThemeImage';
import { track } from 'mod/store/nav/utils';

type INavBannerProps = INavBanner & {
    lv1Item: INavItem;
    lv1Index: number;
    onClose: () => void;
};

export const NavBanner: FC<INavBannerProps> = props => {
    const { column, imgWidth, imgHeight, list, lv1Item, lv1Index, onClose } = props;

    return (
        <Row colsPerRow={column} gutter={process.env.NEXT_PUBLIC_TERMINAL === 'm' ? [20, 32] : 32}>
            {list.map((item, index) => {
                const position = `image.${lv1Index + 1}.${index + 1}`;
                return (
                    <Col
                        key={index}
                        data-t-tar={item.imgUrl}
                        data-t-pos={position}
                    >
                        <Image
                            width={imgWidth}
                            height={imgHeight}
                            src={item.imgUrl}
                            href={item.link}
                            alt={item.alt}
                            onClick={() => {
                                track({
                                    target: item.imgUrl,
                                    relTarget: lv1Item,
                                    position
                                });
                                onClose();
                            }}
                        />
                        <div>{item.title}</div>
                    </Col>
                )
            })}
        </Row>
    )
};
